/* RESPONSIBLE TEAM: team-data-foundations */
import Model, { attr } from '@ember-data/model';
import { fragment, fragmentArray } from 'ember-data-model-fragments/attributes';

export default class AccountSyncData extends Model {
  @attr('string') sectionId;
  @attr() accountMappingSuggestedFields;
  @attr('number') lastAccountMatchDate;
  @fragment('integrations/salesforce/settings') settings;
  @fragmentArray('crm/attribute-mapping') attributeMappings;
  @fragmentArray('salesforce/salesforce-fields') salesforceAccountFields;
  @fragmentArray('integrations/salesforce/identity-mapping-field') accountMappingSupportedFields;
}
